import React from "react";
import { FaExclamationTriangle, FaHome } from "react-icons/fa";

const NotFound = () => {
    return (
        <div className="container-fluid vh-100 d-flex align-items-center justify-content-center bg-light">
            <div className="row">
                <div className="col-md-12 mx-auto">
                    <div className="card border-0 p-20">
                        <div className="card-body">
                            <div className="text-center">


                                <div className="mb-4">
                                    <FaExclamationTriangle
                                        className="text-warning"
                                        size={90}
                                    />
                                </div>

                                <h1 className="display-1 fw-bold text-dark">404</h1>

                                <h3 className="mb-3 text-secondary">
                                    Oops! Page Not Found
                                </h3>

                                <p className="text-muted mb-4">
                                    The page you are looking for might have been removed,
                                    had its name changed, or is temporarily unavailable.
                                </p>

                                <a href="/" className="btn btn-primary  bg-main-two-600 btn-lg px-12  rounded-20 mt-20 shadow">
                                    <FaHome className="me-2" />
                                    Back to Home
                                </a>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default NotFound;